import React from 'react'
import { Grid, Box, Container } from '@mui/material'
import courseList from './data'
import CourseCard from './CourseCard'
import Title from '../title/Title'

export default function Courses() {
    return (
        <Container maxWidth="xl">
            <Title title="Dersler" />
            <Box sx={{ 
                flexGrow: 1, 
                p: { xs: 2, sm: 3, md: 4 },
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center'
            }}>
                <Grid 
                    container 
                    spacing={3}
                    justifyContent="center"
                    alignItems="stretch"
                >
                    {courseList.map((course, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <CourseCard course={course} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    )
}
